import * as Api from '@ViewModels';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { AUTOMATION_QUERY_KEYS } from '../../queryKeys';
import { invalidateAllAutomationTemplatesQueries } from '../../queries/useAutomationTemplatesQuery';

interface MutationVariables {
	id: string;
	impersonationContext?: Api.IImpersonationContext;
}

export function useCancelAllInProgressAutomationsMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: void, variables: MutationVariables) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({ id, impersonationContext }: MutationVariables) => {
			return userSession.webServiceHelper.callAsync<void>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `AutomationTemplate/${encodeURIComponent(id)}/CancelAll`,
					impersonationContext,
				}),
				'POST'
			);
		},
		onError,
		onSuccess: (data, variables) => {
			queryClient.invalidateQueries({ queryKey: AUTOMATION_QUERY_KEYS.template(variables.id) });
			invalidateAllAutomationTemplatesQueries();
			onSuccess?.(data, variables);
		},
	});
}
